import React from 'react';

import { Resources } from '@ragu-components/ord-resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { OauthApplication } from '@ragu-components/ord-types';

const OauthApplicationsList = React.lazy(async () => import('./OauthApplicationsList'));

export const oauthApplicationsResource: OrdResourceProps = {
  key: Resources.oauth_applications,
  name: Resources.oauth_applications,
  list: <OauthApplicationsList />,
  options: {},
  recordRepresentation: (record: OauthApplication): string => record.name,
};
